// extracted by mini-css-extract-plugin
export default {"tabs":"RestaurantHours-module__tabs___7f8Fe"};